import PermissionsSetDetails from './PermissionsSetDetails';

export default PermissionsSetDetails;
